const CARDS_PER_PAGE = 15;

export default class WorkGrid {


	// Constructor
	constructor(asscroll, cursor, element) {

		this.asscroll = asscroll;
		this.asscrollCurrentPos = 0;
		this.asscrollElement = (asscroll) ? asscroll.scrollElements : null;

		this.cursor = cursor;

		this.element = element;
		this.data = JSON.parse(this.element.querySelector('.data').innerHTML);

		this.more = this.element.querySelector('.section-work-grid--more');
		this.moreButton = this.more.querySelector('button');
		this.cardsContainer = this.element.querySelector('.section-work-grid--cards');
		this.noResults = this.cardsContainer.querySelector('p');

		this.servicesButton = this.element.querySelector('.section-work-grid--button-services');
		this.servicesButtonText = this.servicesButton.querySelector('span');
		this.servicesAll = this.servicesButtonText.innerHTML;
		this.serviceId = null;

		this.typesButton = this.element.querySelector('.section-work-grid--button-types');
		this.typesButtonText = this.typesButton.querySelector('span');
		this.typesAll = this.typesButtonText.innerHTML;
		this.typeId = null;

		this.panel = document.createElement('div');
		this.panel.className = 'section-work-grid--panel';
		this.panel.innerHTML = '<button><span class="screen-reader-text">Close</span></button><div><div><button class="section-work-grid--close"><svg class="svg svg-icon-close"><use xlink:href="#icon-close"></use></svg><span class="screen-reader-text">Close</span></button><div></div></div></div>';
		this.panel.setAttribute('aria-hidden', 'true');
		document.body.appendChild(this.panel);
		this.panelCloseButtons = Array.prototype.slice.call(this.panel.querySelectorAll('button'), 0);
		this.panelContent = this.panel.querySelector('div div div div');
		this.panelScroll = this.panel.querySelector('div');

		this.buttonClosePanel = this.buttonClosePanel.bind(this);
		this.buttonMoreClick = this.buttonMoreClick.bind(this);
		this.buttonServicesClick = this.buttonServicesClick.bind(this);
		this.buttonTypesClick = this.buttonTypesClick.bind(this);
		this.hashChanged = this.hashChanged.bind(this);
		this.selectItem = this.selectItem.bind(this);
		this.handlePanelKeyboardNavigation = this.handlePanelKeyboardNavigation.bind(this)

		this.cardCount = 0;
		this.cards = [];
		this.page = 1

		this.returnFocusElement = null

		this.queryParams = new URLSearchParams(window.location.search)

		if (this.queryParams.has('pnum')) {
			this.page = parseInt(this.queryParams.get('pnum'))
		}

		this.hashChanged();

		this.handlePageShow = this.handlePageShow.bind(this)

		window.addEventListener('pageshow', this.handlePageShow)
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.asscrollCurrentPos;
		delete this.asscrollElement;
		delete this.cardCount;
		delete this.cards;
		delete this.cardsContainer;
		delete this.cursor;
		delete this.data;
		delete this.element;
		delete this.more;
		delete this.moreButton;
		delete this.noResults;
		delete this.panel;
		delete this.panelCloseButtons;
		delete this.panelContent;
		delete this.panelScroll;
		delete this.serviceId;
		delete this.servicesAll;
		delete this.servicesButton;
		delete this.servicesButtonText;
		delete this.typeId;
		delete this.typesAll;
		delete this.typesButton;
		delete this.typesButtonText;
		delete this.page
		delete this.queryParams
	}
	enable() {
		this.disable();
		this.panelCloseButtons[0].addEventListener('click', this.buttonClosePanel);
		this.panelCloseButtons[1].addEventListener('click', this.buttonClosePanel);
		this.moreButton.addEventListener('click', this.buttonMoreClick);
		this.servicesButton.addEventListener('click', this.buttonServicesClick);
		this.typesButton.addEventListener('click', this.buttonTypesClick);
		this.panelContent.addEventListener('click', this.selectItem);
		// window.addEventListener('hashchange', this.hashChanged, false);
	}
	disable() {
		this.panelCloseButtons[0].removeEventListener('click', this.buttonClosePanel);
		this.panelCloseButtons[1].removeEventListener('click', this.buttonClosePanel);
		this.moreButton.removeEventListener('click', this.buttonMoreClick);
		this.servicesButton.removeEventListener('click', this.buttonServicesClick);
		this.typesButton.removeEventListener('click', this.buttonTypesClick);
		this.panelContent.removeEventListener('click', this.selectItem);
		// window.removeEventListener('hashchange', this.hashChanged, false);
	}


	// Event Handlers
	buttonClosePanel(event) {
		event.preventDefault();
		if (this.asscroll) {
			this.asscroll.disable();
			this.asscroll.currentPos = this.asscrollCurrentPos;
			this.asscroll.enable({ newScrollElements: this.asscrollElement });
		}
		this.panel.classList.remove('show');
		this.panel.setAttribute('aria-hidden', 'true');
	}
	buttonMoreClick(event) {
		event.preventDefault();

		this.page += 1
		this.queryParams.set('pnum', this.page)

		window.history.replaceState({}, '', `${ window.location.pathname }?${ this.queryParams.toString() }`)
		this.isPageUpdate = true
		this.addCards()
	}

	buttonServicesClick(event) {
		event.preventDefault();

		var html = `<button class="${ this.serviceId === null ? 'active' : '' }" data-type="services" data-id=""><span>${ this.servicesAll }</span></button>`

		html += this.data.services.map((service) => {
			let isActive = this.serviceId == service.id
			return `<button class="${ isActive ? 'active' : '' }" data-type="services" data-id="${ service.id }"><span>${ service.title }</span></button>`
		}).join('')

		this.panelContent.innerHTML = html;

		if (this.asscroll) {
			this.asscrollCurrentPos = this.asscroll.currentPos;
			this.asscroll.disable();
			this.asscroll.enable({ newScrollElements: this.panelScroll, reset: true });
		}
		this.panel.classList.add('show');
		this.panel.setAttribute('aria-hidden', 'false');
		this.focusActive(event.target)
	}

	buttonTypesClick(event) {
		event.preventDefault();

		var html = `<button class="${ this.typeId === null ? 'active' : '' }" data-type="types" data-id=""><span>${ this.typesAll }</span></button>`

		html += this.data.types.map((type) => {
			let isActive = this.typeId == type.id
			return `<button class="${ isActive ? 'active' : '' }" data-type="types" data-id="${ type.id }"><span>${ type.title }</span></button>`
		}).join('')

		this.panelContent.innerHTML = html;

		if (this.asscroll) {
			this.asscrollCurrentPos = this.asscroll.currentPos;
			this.asscroll.disable();
			this.asscroll.enable({ newScrollElements: this.panelScroll, reset: true });
		}

		this.panel.classList.add('show');
		this.panel.setAttribute('aria-hidden', 'false');

		this.focusActive(event.target)
	}

	focusActive(returnFocusElement) {

		this.returnFocusElement = returnFocusElement

		let activeOption = this.panel.querySelector('.active')
		if (activeOption) {
			activeOption.focus()
			this.asscroll.scrollTo(activeOption.getBoundingClientRect().top)
		}

		window.addEventListener('keyup', this.handlePanelKeyboardNavigation)
	}

	returnFocus() {
		if (this.returnFocusElement) {
			this.returnFocusElement.focus()
		}
	}

	handlePanelKeyboardNavigation(e) {

		// User hit escape. Close the panel
		if (e.keyCode == 27) {
			return this.buttonClosePanel(e)
		}

	  let focasables;
	  if (e.key == 'Tab') {
	    focasables = this.panel.querySelectorAll("a, input, select, button");

	    if (focasables) {
	      const firstElem = focasables[0];
	      const lastElem = focasables[(focasables.length - 1)];
	      if (e.target == firstElem && e.shiftKey) {
	        e.preventDefault();
	        lastElem.focus();
	      } else if (e.target == lastElem && !e.shiftKey) {
	        e.preventDefault();
	        firstElem.focus();
	      }
	    }
	  }
	}


	hashChanged() {

		// Prevent filter updates when just updating the page
		if (this.isPageUpdate === true) {
			this.isPageUpdate = null
			return;
		}

		var i, l;

		let serviceId;
		let typeId;

		var serviceName = this.servicesAll;
		if (this.queryParams.has('service')) {
			serviceId = (this.queryParams.get('service') == '') ? null : parseInt(this.queryParams.get('service'));
			let service = this.data.services.find((service) => service.id == serviceId)
			if (service) {
				serviceName = service.title
			}
		}

		var typeName = this.typesAll;
		if (this.queryParams.get('type')) {
			typeId = (this.queryParams.get('type') == '') ? null : parseInt(this.queryParams.get('type'));
			if (typeId) {
				let type = this.data.types.find((type) => type.id == typeId)
				if (type) {
					typeName = type.title
				}
			}
		}

		if (this.queryParams.get('pnum')) {
			this.page = parseInt(this.queryParams.get('pnum')) || 1;
		}

		this.servicesButtonText.innerHTML = serviceName;
		this.typesButtonText.innerHTML = typeName;

		this.serviceId = serviceId;
		this.typeId = typeId;

		this.updateCards();
	}

	selectItem(event) {
		event.preventDefault();
		var button = event.target;
		if (button.tagName !== 'BUTTON') {
			button = button.parentNode;
		}
		if (button.tagName === 'BUTTON') {
			var type = button.getAttribute('data-type');
			var id = button.getAttribute('data-id');

			if (type === 'services') {
				this.queryParams.set('service', id)
			} else if (type === 'types') {
				this.queryParams.set('type', id)
			}

			// Reset the page number on filter change
			this.page = 1
			this.queryParams.set('pnum', this.page)
			
			window.history.replaceState({}, '', `${ window.location.pathname }?${ this.queryParams.toString() }`)
			this.hashChanged()
		}

		this.buttonClosePanel(event);
	}


	// Helpers
	addCards() {

		let limit = CARDS_PER_PAGE * this.page

		// add our cards
		for (var i=this.cardCount, l=limit; i<l; i++) {
			this.cardCount += 1;
			if (i < this.cards.length) {
				this.addCard(this.cards[i]);
			}
		}

		// hide/show more button
		if (this.cardCount >= this.cards.length) {
			this.more.classList.add('hide');
		} else {
			this.more.classList.remove('hide');
		}

		// Trigger window to resize event to fix ASScroll's height issues
		if (this.asscroll) {
			window.dispatchEvent(new Event('resize'));
		}

		// Update our cursor hovers
		if (this.cursor) {
			this.cursor.updateHovers();
		}
	}

	addCard(item) {
		var card = document.createElement('article');
		card.id = item.post_name
		var html = '';
		if (item.type === 'post') {
			html += '<div><span>';
				html += '<h4>Insights</h4>';
				html += '<h5>' + item.title + '</h5>';
				html += '<p><a class="arrow-link" href="' + item.url + '" title="Learn More"><strong><span>Learn More</span><span aria-hidden="true">Learn More</span></strong><i aria-hidden="true"><span><svg class="svg svg-arrow-right"><use xlink:href="#arrow-right"></use></svg></span><span><svg class="svg svg-arrow-right"><use xlink:href="#arrow-right"></use></svg></span></i></a></p>';
			html += '</span></div>';
			card.className = 'card-info is-square';
			card.id = item.post_name
			card.innerHTML = html;
			this.cardsContainer.appendChild(card);
		} else if (item.type === 'project') {

			html += `<a href="${item.url}" title="${item.title}">`//data-cursor-text="Explore" 
				html += '<div class="card-page--image">';
					if (item.img) {
						html += `<div class="card-page--img">${item.img}</div>`;
					}
					if (item.badges) {
						html += item.badges;
					}
					if (item.desc) {
						html += `<p><span>${item.desc}</span></p>`;
					}
				html += '</div>';
				html += '<div class="card-page--text">';
					html += `<h3><span>${item.title}</span></h3>`;
					if (item.subtitle) {
						html += `<h4><span>${item.subtitle}</span></h4>`;
					}
				html += '</div>';
			html += '</a>';
			card.className = 'card-page is-square';
			card.innerHTML = html;
			this.cardsContainer.appendChild(card);
		}
	}
	updateCards() {

		var i, l, card;

		let filters = [];

		if (this.serviceId != null) {
			filters.push({ key: 'services', value: this.serviceId })
		}

		if (this.typeId != null) {
			filters.push({ key: 'types', value: this.typeId })
		}

		var projects = this.data.projects.filter((post) => {

			if (filters.length == 0) {
				return true;
			}

			return filters.every((filter) => post[filter.key].includes(filter.value))
		})

		var posts = this.data.posts.filter((post) => {

			if (filters.length == 0) {
				return true;
			}

			return filters.every((filter) => post[filter.key].includes(filter.value))
		})

		this.cardCount = 0;
		this.cards = [];
		this.cardsContainer.innerHTML = '';
		this.more.classList.add('hide');
		if (projects.length === 0) {
			this.cardsContainer.appendChild(this.noResults);
		} else {
			for (i=0, l=projects.length; i<l; i++) {

				card = projects[i];
				card.type = 'project';
				this.cards.push(card);

				if (i > 0 && (i + 1) % 6 === 0 && posts.length > 0) {
					card = posts.pop();
					card.type = 'post';
					this.cards.push(card);
				}

			}
			this.addCards();
		}

	}

	handlePageShow() {
		const prevUrlFromStorage = localStorage.getItem('previous_url')

		if (!prevUrlFromStorage) {
			return;
		}

		const prevUrl = new URL(prevUrlFromStorage)
		if (prevUrl.pathname.includes('work/project')) {
			const urlMatches = prevUrl.pathname.match(/project\/([^\/]+)/)

			if (!urlMatches) {
				return;
			}

			const articleCard = document.getElementById(urlMatches[1])
			if (!articleCard) {
				return;
			}


			setTimeout(() => {

				const cardRect = articleCard.getBoundingClientRect()

				if (cardRect.top + cardRect.height > window.innerHeight) {
					const top = Math.abs(this.element.getBoundingClientRect().top) + cardRect.top
					this.asscroll.scrollTo(top)
				}

			}, 500)
		}
	}
}
